import React, { useState, useEffect } from 'react';
import logoImage from '../../../assets/images/logo.png';
import { mainNavItems } from '../data/index';
import { useNavigation } from '../hooks/useNavigation';
import { NavbarProps } from '../types';
import NavbarPresentation from './NavbarPresentation';

/**
 * Container component for Navbar, responsible for logic and state
 */
const NavbarContainer: React.FC<NavbarProps> = ({ className }) => {
  // State for the navbar
  const [scrolled, setScrolled] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(true);

  // Use navigation hook
  useNavigation();

  // Handle scroll effect for navbar appearance
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Use the directly imported logo
  const logoSrc = logoImage;
  
  return (
    <NavbarPresentation
      isScrolled={scrolled}
      logoLoaded={logoLoaded}
      setLogoLoaded={setLogoLoaded}
      logoSrc={logoSrc}
      navItems={mainNavItems}
    />
  );
};

export default NavbarContainer;